import { render } from "./EditFormPage.vue?vue&type=template&id=54c4ab12&scoped=true&ts=true"
import script from "./EditFormPage.vue?vue&type=script&lang=ts"
export * from "./EditFormPage.vue?vue&type=script&lang=ts"

import "./EditFormPage.vue?vue&type=style&index=0&id=54c4ab12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c4ab12"]])

export default __exports__